<template>
  <div>
    <b-alert :variant="alert.type"
      dismissible
      fade
      :show="alert.show"
      @dismissed="alert.show=false"
    >{{ alert.message }}</b-alert>
    <div class="row">
      <h1 class="ml-2">Feiertage</h1>
      <b-form-datepicker
        v-model="selectedDate" 
        start-weekday="1"
        value-as-date
        class="col-md-3 ml-auto mb-4 mx-2"/>
      <b-form-select class="col-md-1 mx-1" v-model="newHoliday.countryIso" :options="countries"></b-form-select>
      <b-button size="md" @click="save()" class="float-right mb-4 mr-4">
        <span class="icon icon-plus"></span>
      </b-button>
    </div>
    <b-table class="mt-3" :items="holidays" :fields="tableConfig.fields" striped hover>
      <template v-slot:cell(actions)="data">
        <b-button size="md" @click="remove(data.item)" class="float-right">
          <span class="icon icon-bin"></span>
        </b-button>
      </template>
    </b-table>
    <modal-error-component v-model="modalError"></modal-error-component>
  </div>
</template>
<script>
export default {
  props: [ 'passedCountries', 'passedHolidays' ],
  data () {
    return {
      currencies: [],
      selectedDate: new Date(),
      holidays: [],
      countries: [],
      newHoliday: {
        date: null,
        countryIso: null,
      },
      tableConfig: {
        fields: [
          { key: "date", label: "Datum" },
          { key: "countryIso", label: "Land" },
          { key: "actions", label: "" }
        ]
      },
      modalError: {
        show: false,
        message: 'unpopulated',
        error: 'unpopulated',
        title: 'unpopulated'
      },
      alert: {
        show: false,
        message: null,
        type: null,
      },
    }
  },
  methods: {
    save() {
      this.alert.show = false;
      axios.get("/holiday/create", { params: this.newHoliday }).then( response => {
        if (response.status >= 200 && response.status < 400) { 
          this.holidays.push(response.data);
          this.holidays = this.holidays.sort((a,b) => { return b.date.localeCompare(a.date); }).slice(0,20);
          this.newHoliday = {
            date: null,
            countryIso: null,
          }
          this.alert = {
            show: true,
            message: "Feiertag wurde erfolgreich angelegt.",
            type: 'success',
          };
        }
        else
        {
          this.modalError = {
            show: true,
            message: "Feiertag konnte nicht abgespeichert werden.",
            error: "",
            title: "Feiertag Speichervorgang"
          };
        }
      }).catch(error => {
        this.modalError = {
          show: true,
          message: "Feiertag konnte nicht abgespeichert werden.",
          error: error,
          title: "Feiertag Speichervorgang"
        };
      });
    },
    remove(elem) {
      this.alert.show = false;
      axios.post('/holiday/remove', elem).then((response) => {
        if(response.status >= 200 && response.status < 400) {
          this.alert = {
            show: true,
            message: "Feiertag wurde erfolgreich gelöscht.",
            type: 'success',
          };
          this.holidays = this.holidays.filter((x) => { return ((x.date !== elem.date) && (x.countryIso !== elem.countryIso)) });
        }else{
          this.modalError = {
            show: true,
            message: 'Konnte den Feiertag nicht löschen.',
            error: response,
            title: 'Eintrag Löschen'
          };
        }  
      }).catch((error) => {
        this.modalError = {
          show: true,
          message: 'Konnte den Feiertag nicht löschen.',
          error: error,
          title: 'Eintrag Löschen'
        };
      });
    },
    formatDate() {
      this.newHoliday.date = (this.selectedDate.getYear() + 1900) + '-' + (this.selectedDate.getMonth() + 1) + '-' + this.selectedDate.getDate();
    }
  },
  watch: {
    selectedDate: function() { this.formatDate() }
  },
  mounted() {
    this.holidays = this.passedHolidays.sort((a,b) => { return b.date.localeCompare(a.date); });  
    this.holidays = this.holidays.map((holiday) => { return {
      id: holiday.id,
      country: this.passedCountries.find((country) => { return country.countryIso == holiday.countryIso }),
      countryIso: holiday.countryIso,
      date: holiday.date
    }});
    this.countries = this.passedCountries.map((country) => {
      return {
        value: country.countryIso,
        text: country.countryIso
      };
    });
    this.formatDate()
  }
}
</script>
